// extracted by mini-css-extract-plugin
module.exports = {"btnlogin":"ButtonLogin_btnlogin__2jF4P","btnLoginLink":"ButtonLogin_btnLoginLink__2BjFo"};